import useAppStore from '../store/app.store';

const ESCURO = {
  bgPage:       '#0B1220',
  bgSidebar:    '#131D31',
  bgCard:       '#131D31',
  bgCardAlt:    '#19243A',
  bgCardHover:  '#1F2B45',
  bgInput:      '#19243A',
  border:       '#2A3652',
  borderLight:  '#1E293B',
  text:         '#E2E8F0',
  textSecond:   '#94A3B8',
  textMuted:    '#64748B',
  textTitle:    '#F1F5F9',
  badge:        '#0B1220',
};

const CLARO = {
  bgPage:       '#F1F5F9',
  bgSidebar:    '#131D31', // sidebar sempre escura
  bgCard:       '#FFFFFF',
  bgCardAlt:    '#F8FAFC',
  bgCardHover:  '#F1F5F9',
  bgInput:      '#F8FAFC',
  border:       '#E2E8F0',
  borderLight:  '#F1F5F9',
  text:         '#0F172A',
  textSecond:   '#475569',
  textMuted:    '#94A3B8',
  textTitle:    '#0F172A',
  badge:        '#F1F5F9',
};

export default function useTema() {
  const tema = useAppStore(s => s.tema);
  return tema === 'claro' ? CLARO : ESCURO;
}
